import React, { useState, useEffect } from 'react';
import { Assessment } from '@mui/icons-material';

interface MarketInsightsMarketDataPlaceholderProps {
  onConfigure: () => void;
}

const MarketInsightsMarketDataPlaceholder: React.FC<MarketInsightsMarketDataPlaceholderProps> = ({ onConfigure }) => {
  const [screenSize, setScreenSize] = useState<'mobile' | 'tablet' | 'desktop'>('desktop');

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      if (width < 768) {
        setScreenSize('mobile');
      } else if (width < 1024) {
        setScreenSize('tablet');
      } else {
        setScreenSize('desktop');
      }
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const isMobile = screenSize === 'mobile';
  const isTablet = screenSize === 'tablet';

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: isMobile ? '1rem' : isTablet ? '2rem' : '3rem',
      textAlign: 'center',
      width: isMobile ? '75vw' : isTablet ? '75vw' : '500px',
      maxWidth: isMobile ? '350px' : '500px',
      background: '#fff',
      borderRadius: 12,
      boxShadow: '0 2px 12px rgba(0,0,0,0.06)',
      margin: isMobile ? '0 auto' : undefined
    }}>
      {/* Icon */}
      <div style={{
        width: isMobile ? '60px' : '80px',
        height: isMobile ? '60px' : '80px',
        background: 'linear-gradient(115deg, rgb(34, 34, 69) 25%, rgb(77, 182, 159) 162%)',
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        margin: isMobile ? '0 auto 1.5rem' : '0 auto 2rem',
        fontSize: '2rem'
      }}>
        <Assessment style={{ color: 'white', fontSize: isMobile ? '2rem' : '3rem' }} />
      </div>

      {/* Title */}
      <h2 style={{
        fontSize: isMobile ? '1.25rem' : isTablet ? '1.5rem' : '1.75rem',
        fontWeight: 600,
        color: '#1a202c',
        marginBottom: '1rem',
        lineHeight: '1.3'
      }}>
        Market Data Settings Required
      </h2>

      {/* Description */}
      <p style={{
        fontSize: isMobile ? '0.9rem' : isTablet ? '1rem' : '1.1rem',
        color: '#4a5568',
        lineHeight: 1.6,
        marginBottom: isMobile ? '1.5rem' : '2rem',
        maxWidth: isMobile ? '100%' : '500px',
        padding: isMobile ? '0 0.25rem' : '0'
      }}>
        To view Market Insights, please complete your organization market data settings to enable real time analysis.
      </p>

      {/* Helpful list */}
      <div style={{
        background: '#f7fafc',
        borderRadius: 12,
        padding: isMobile ? '1rem' : '1.5rem',
        marginBottom: isMobile ? '1.5rem' : '2rem',
        textAlign: 'left',
        maxWidth: isMobile ? '90%' : '400px',
        width: '90%'
      }}>
        <h3 style={{
          fontSize: isMobile ? '0.85rem' : '1rem',
          fontWeight: 600,
          color: '#2d3748',
          marginBottom: '1rem',
          lineHeight: '1.4'
        }}>
          Utilising the data you give and information available on the internet, we will generate market insights to help you make informed decisions. The more thorough you are, the more helpful the analysis will be.
        </h3>
        
      </div>

      {/* Configure button */}
      <button
        onClick={onConfigure}
        style={{
          background: 'linear-gradient(115deg, rgb(34, 34, 69) 25%, rgb(77, 182, 159) 162%)',
          color: '#fff',
          border: 'none',
          borderRadius: 12,
          padding: isMobile ? '0.875rem 1.5rem' : '1rem 2rem',
          fontSize: isMobile ? '1rem' : '1.1rem',
          fontWeight: 600,
          cursor: 'pointer',
          transition: 'all 0.2s ease',
          boxShadow: '0 4px 12px rgba(102, 126, 234, 0.3)',
          minWidth: isMobile ? '180px' : '220px',
          width: isMobile ? '100%' : 'auto',
          maxWidth: isMobile ? '280px' : 'none'
        }}
        onMouseOver={(e) => {
          e.currentTarget.style.transform = 'translateY(-2px)';
          e.currentTarget.style.boxShadow = '0 6px 16px rgba(102, 126, 234, 0.4)';
        }}
        onMouseOut={(e) => {
          e.currentTarget.style.transform = 'translateY(0)';
          e.currentTarget.style.boxShadow = '0 4px 12px rgba(102, 126, 234, 0.3)';
        }}
      >
        Add Market Data
      </button>
    </div>
  );
};

export default MarketInsightsMarketDataPlaceholder;
